(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@usig-gcba/usig-core"), require("isomorphic-fetch"));
	else if(typeof define === 'function' && define.amd)
		define("Callejero", ["@usig-gcba/usig-core", "isomorphic-fetch"], factory);
	else if(typeof exports === 'object')
		exports["Callejero"] = factory(require("@usig-gcba/usig-core"), require("isomorphic-fetch"));
	else
		root["Callejero"] = factory(root["@usig-gcba/usig-core"], root["isomorphic-fetch"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition